module.exports = __webpack_public_path__ + "static/media/chess-clock.9ea0fa30.svg";